import { render, staticRenderFns } from "./EnviarErrores.vue?vue&type=template&id=4461962a&"
import script from "./EnviarErrores.vue?vue&type=script&lang=js&"
export * from "./EnviarErrores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports